import { openType, pathType, showType,RouteLevel } from "@u/interface/route/route"
//原始菜单数据，也就是从接口返回的数据
export interface IOriginalMenu{
    cTime: string  //创建时间
    clientType: IClientType
    code: string   //就是路由名
    icon:string    //图标
    id: string
    isEnable: boolean   //是否启用
    level: RouteLevel    //路由层级
    openType:   openType    //打开方式，
    parentId:   string    //父id
    path: string    //路由的 path
    pathType:   pathType    //链接类型
    showType: showType    //显示类型
    sort: number    //排序
    title: string    //页面标题
    uTime: string    //更新时间
    children?: IOriginalMenu[]
    label?: string
    value?: string
    [key: string]: any
}
export enum IClientType {
    pc = 1
}
export type ILevel = 1 | 2 | 3